import { useQuery } from "react-query";
import {
  apiListClientDiscardedValuations,
  IApiListClientDiscardedValuationsParams,
} from "../../../../../api/valuation/apiListClientDiscardedValuations";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { valuationKeys } from "./valuation.query-keys";

type QueryFnType = typeof apiListClientDiscardedValuations;

type TUseClientDiscardedValuationsOptions = {
  params: IApiListClientDiscardedValuationsParams;
  config?: QueryConfig<QueryFnType>;
};

export const useClientDiscardedValuations = ({
  params,
  config,
}: TUseClientDiscardedValuationsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: valuationKeys.clientDiscardedForCandidate(params),
    queryFn: () => apiListClientDiscardedValuations(params),
  });
};
